import { render, staticRenderFns } from "./ShippingRates.vue?vue&type=template&id=0fb2311e&scoped=true"
import script from "./ShippingRates.vue?vue&type=script&lang=js"
export * from "./ShippingRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2311e",
  null
  
)

export default component.exports